import { render } from "./CheckPage.vue?vue&type=template&id=b505a6b4"
import script from "./CheckPage.vue?vue&type=script&lang=js"
export * from "./CheckPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__